<template>
  <div class="card">
    <div class="card-header"><i class="fa fa-files-o"></i> Fichiers joints</div>

    <div class="card-body">
      <div class="p-1 pb-2">
        <el-table :data="files" max-height="320" style="width: 100%">
          <el-table-column
            prop="label"
            label="Type"
            min-width="150"
            fixed
          ></el-table-column>
          <el-table-column prop="name" label="Nom" width="120">
            <template slot-scope="scope">
              <span v-tooltip="{ content: scope.row.name, placement: 'top' }">{{
                formatFilename(scope.row.name)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="refUser" label="Transmis par" width="160">
            <template slot-scope="scope">
              <a :href="getUserHref(scope.row.refUser)" target="_blank">{{
                scope.row.refUser.name
              }}</a>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" label="Transmis le" width="100">
            <template slot-scope="scope">
              {{ formatDate(scope.row.createdAt) }}
            </template>
          </el-table-column>
          <el-table-column label="Actions" width="100" align="right">
            <template slot-scope="scope">
              <button
                class="btn btn-sm btn-outline-info"
                :disabled="downloadingIds.includes(scope.row.id)"
                @click="downloadFile(scope.row.id)"
              >
                <i class="fa fa-download"></i>
              </button>
              <button
                v-if="
                  hasPermission($store.state.user, 'ORDER_COACHS_FILES_WRITE')
                "
                class="btn btn-sm btn-outline-danger ml-05"
                :disabled="deletingIds.includes(scope.row.id)"
                @click="deleteFile(scope.row)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import DownloadFile from "@/mixin/DownloadFile";

export default {
  mixins: [DownloadFile],

  props: {
    files: {
      type: Array,
      default: () => [],
    },

    orderId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      downloadingIds: [],
      deletingIds: [],
    };
  },

  methods: {
    getUserHref(user) {
      const route = this.$router.resolve({
        name: "user-details",
        params: { id: user.id },
      });

      return route.href;
    },

    formatFilename(filename) {
      return filename.length > 10
        ? filename.substring(0, 5) +
            "..." +
            filename.substring(filename.length - 5)
        : filename;
    },

    async downloadFile(id) {
      try {
        this.downloadingIds.push(id);

        await this.downloadSecuredFile(`/uploads/document/${id}`);
      } catch (e) {
        this.$errorToast("Impossible de télécharger le fichier");
      } finally {
        this.downloadingIds = this.downloadingIds.filter((id) => id !== id);
      }
    },

    deleteFile(file) {
      this.$confirm({
        message: `Voulez-vous vraiment supprimer le fichier ${
          file.label ? `"${file.label}" (${file.name})` : file.name
        } ${file.refUser?.name ? `transmis par ${file.refUser.name} ` : ""} ?`,
        onConfirm: () => this.handleDeleteFile(file.id),
      });
    },

    async handleDeleteFile(id) {
      try {
        this.deletingIds.push(id);

        await this.$api.delete(`/orders/${this.orderId}/coachs-files/${id}`);

        this.$successToast("Fichier supprimé avec succès");

        this.$emit("deleted", id);
      } catch (e) {
        this.$errorToast("Impossible de supprimer le fichier");
      } finally {
        this.deletingIds = this.deletingIds.filter((id) => id !== id);
      }
    },
  },
};
</script>
